module.exports = __webpack_public_path__ + "img/6.db4181ab.jpeg";